import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import StafetActions from '../StafetActions/StafetActions.vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import { ref, computed, onBeforeMount } from 'vue'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import fieldsConfig from './config/fieldsConfig'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagSomFighterStepOne',
    components: {
        StafetActions,
        FormInputTextField,
        FormCheckbox
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const firstTimeFighter = ref(false)
        const firstName = ref('')
        const lastName = ref('')
        const email = ref('')
        const phone = ref('')
        const consent = ref(false)
        const fighterNewsletter = ref(false)
        const readOnly = ref({
            firstName: false,
            lastName: false,
            email: false,
            phone: false
        })

        const disableValidation = (fieldName) => {
            const field = fieldsConfig.find(field => field.name === fieldName)
            field.validator = _ => true
        }

        onBeforeMount(() => {

            if (props.userData) {
    
                if (props.userData.firstName) {
                    firstName.value = props.userData.firstName
                    readOnly.value.firstName = true
                    disableValidation('firstName')
                }
    
                if (props.userData.lastName) {
                    lastName.value = props.userData.lastName
                    readOnly.value.lastName = true
                    disableValidation('lastName')
                }
    
                if (props.userData.email) {
                    email.value = props.userData.email
                    readOnly.value.email = true
                    disableValidation('email')
                }
    
                if (props.userData.phoneNumber) {
                    phone.value = props.userData.phoneNumber
                    readOnly.value.phone = true
                    disableValidation('phone')
                }
            }
            
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_AS_FIGHTER
            )

            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'firstTimeFighter',
                        value: getFieldValue(storedFields, 'firstTimeFighter')
                    },
                    {
                        name: 'firstName',
                        value: getFieldValue(storedFields, 'firstName')
                    },
                    {
                        name: 'lastName',
                        value: getFieldValue(storedFields, 'lastName')
                    },
                    {
                        name: 'email',
                        value: getFieldValue(storedFields, 'email')
                    },
                    {
                        name: 'phone',
                        value: getFieldValue(storedFields, 'phone')
                    },
                    {
                        name: 'consent',
                        value: getFieldValue(storedFields, 'consent')
                    },
                    {
                        name: 'fighterNewsletter',
                        value: getFieldValue(storedFields, 'fighterNewsletter')
                    }
                ])
            } else {
                updateLocalRefs([
                    {
                        name: 'firstTimeFighter',
                        value: firstTimeFighter.value
                    },
                    {
                        name: 'firstName',
                        value: firstName.value
                    },
                    {
                        name: 'lastName',
                        value: lastName.value
                    },
                    {
                        name: 'email',
                        value: email.value
                    },
                    {
                        name: 'phone',
                        value: phone.value
                    }
                ])
            }
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value =
                    field.value
                switch (field.name) {
                    case 'firstTimeFighter':
                        firstTimeFighter.value = field.value
                        return
                    case 'firstName':
                        firstName.value = field.value
                        return
                    case 'lastName':
                        lastName.value = field.value
                        return
                    case 'email':
                        email.value = field.value
                        return
                    case 'phone':
                        phone.value = field.value
                        return
                    case 'consent':
                        consent.value = field.value
                        return
                    case 'fighterNewsletter':
                        fighterNewsletter.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const setFirstTimeFighter = (value) => {
            firstTimeFighter.value = value
            validateField('firstTimeFighter', value)
        }

        const setFighterNewsletter = (value) => {
            fighterNewsletter.value = value
            validateField('fighterNewsletter', value)
        }

        const setConsent = (value) => {
            consent.value = value
            validateField('consent', value)
        }

        const showFirstNameErrorMessage = computed(() => showError('firstName', firstName.value))
        const showLastNameErrorMessage = computed(() => showError('lastName', lastName.value))
        const showEmailErrorMessage = computed(() => showError('email', email.value))
        const showPhoneErrorMessage = computed(() => showError('phone', phone.value))
        const showError = (fieldName, value) => {
            const field = fieldsConfig.find(field => field.name === fieldName)
            return !field.validator(value) && props.displayInputError
        }

        const showConsentErrorMessage = computed(() => {
            return consent.value === false && props.displayInputError
        })

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            firstTimeFighter,
            firstName,
            lastName,
            email,
            phone,
            consent,
            fighterNewsletter,
            readOnly,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showEmailErrorMessage,
            showPhoneErrorMessage,
            showConsentErrorMessage,
            stepModel,
            setFirstTimeFighter,
            setConsent,
            setFighterNewsletter,
            validateField
        }
    }
}
